import React, { useEffect } from "react";
import "./i18n";
import AppRoutes from "./routes/AppRoutes";
import { useDispatch } from "react-redux";
import {
  setVendor,
  setAuthenticated,
  setLoading,
} from "./redux/slices/authSlice";
import Notification from "./components/Notification";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const token = localStorage.getItem("jwtToken");
      const vendorString = localStorage.getItem("vendor");

      if (token) {
        dispatch(setAuthenticated(true));

        if (vendorString && vendorString !== "undefined") {
          dispatch(setVendor(JSON.parse(vendorString)));
        }
      }
    } catch {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("vendor");
      dispatch(setAuthenticated(false));
    } finally {
      // Ensure the app stops loading even if no token is present
      dispatch(setLoading(false));
    }
  }, [dispatch]);

  return (
    <div className="bg-white w-full">
      <AppRoutes />
      <Notification />
    </div>
  );
}

export default App;
